import React from "react";

const DepositTab = () => {
  return (
    <div>
      <div className="px-64 p-6 text-center border border-opaBorderColor border-solid text-bodyColor font-Inter text-2xl not-italic font-medium leading-normal rounded-lg">
        BTC
      </div>
      <div className="flex justify-between items-center mt-4">
        <div className="text-bodyColor font-Inter text-base not-italic font-medium leading-normal">
          Max: 0 BTC
        </div>
        <div className="flex gap-2 items-center">
          <button className="px-3 py-2 bg-submitButtonColor text-white rounded-lg">
            Half
          </button>
          <button className="px-3 py-2 bg-submitButtonColor text-white rounded-lg">
            max
          </button>
        </div>
      </div>

      {/* Timeline */}
      <div className="flex justify-start items-center h-timelineHeight bg-white mt-10 mr-3">
        <div className="flex mr-auto items-center w-6 h-6 bg-backgroundColor rounded-full"></div>
        <div className="flex mr-auto items-center w-3 h-3 bg-backgroundColor rounded-full"></div>
        <div className="flex mr-auto items-center w-3 h-3 bg-backgroundColor rounded-full"></div>
        <div className="flex mr-auto items-center w-3 h-3 bg-backgroundColor rounded-full"></div>
        <div className="flex items-center w-3 h-3 bg-backgroundColor rounded-full"></div>
      </div>
      <div className="flex justify-start items-center mt-3 mr-3 text-bodyColor font-Inter text-base not-italic font-medium leading-normal">
        <div className="mr-auto">0%</div>
        <div className="mr-auto translate-x-1/2">25%</div>
        <div className="mr-auto translate-x-1/2">50%</div>
        <div className="mr-auto translate-x-1/2">75%</div>
        <div className="translate-x-1/2">100%</div>
      </div>

      <div className="flex justify-between items-center mt-12">
        <div className="text-bodyColor font-Inter text-lg not-italic font-semibold leading-normal">
          Deposited
        </div>
        <div className="text-bodyColor font-Inter text-lg not-italic font-semibold leading-normal">
          11.22 BTC
        </div>
      </div>
      <div className="flex justify-between items-center mt-4">
        <div className="text-bodyColor font-Inter text-lg not-italic font-semibold leading-normal">
          APY
        </div>
        <div className="text-submitButtonColor font-Inter text-lg not-italic font-semibold leading-normal">
          0.22%
        </div>
      </div>
      <div className="flex justify-between items-center mt-4 mb-8">
        <div className="text-bodyColor font-Inter text-lg not-italic font-semibold leading-normal">
          Wallet
        </div>
        <div className="text-bodyColor font-Inter text-lg not-italic font-semibold leading-normal">
          0 BTC
        </div>
      </div>
    </div>
  );
};

export default DepositTab;
